import { createAction } from '@reduxjs/toolkit';
import { promoSearchCouponsSlice } from './reducer';

export const fetchPromoSearchCoupons = createAction('promoSearchCoupons/fetchPromoSearchCoupons');

export const { clearPromoSearchCoupons, setPromoSearchCoupons, setIsFetching } = promoSearchCouponsSlice.actions;
